import React, { useEffect, useState, useRef } from 'react';
import { createPortal } from 'react-dom';
import { useModal } from '../../components';
import { ModalContentContainer, ModalContent, CloseButton, Overlay } from './styled';
export function Modal({ modal, isOpen, close, children }) {
    const modalRoot = useModal(modal.id, isOpen);
    const [animation, setAnimation] = useState('out');
    const modelContentRef = useRef(null);
    useEffect(() => {
        if (isOpen) {
            setAnimation('in');
            window.addEventListener('keydown', escPress);
            document.body.classList.add('prevent-scroll');
        }
        return () => {
            window.removeEventListener('keydown', escPress);
            document.body.classList.remove('prevent-scroll');
        };
    }, [isOpen]);
    const escPress = (event) => {
        if (event.key === 'Escape') {
            closeModal();
        }
    };
    const closeModal = () => {
        setAnimation('out');
    };
    const onAnimationEnd = () => {
        if (animation === 'out') {
            close();
        }
    };
    if (!modalRoot) {
        return null;
    }
    return createPortal(React.createElement(Overlay, { "data-testid": `ui-modal-${modal.id}-overlay`, animation: animation, transitionSpeed: modal.content.transitionSpeed, onAnimationEnd: onAnimationEnd },
        React.createElement(ModalContentContainer, { "data-testid": `ui-modal-${modal.id}-container`, ref: modelContentRef, transitionSpeed: modal.content.transitionSpeed, transitionType: modal.content.transitionType, animation: animation, onClick: (event) => {
                if (event.target === modelContentRef.current) {
                    closeModal();
                }
            } },
            React.createElement(ModalContent, { "data-testid": `ui-modal-${modal.id}-content`, modalSize: modal.content.modalSize },
                React.createElement(CloseButton, { "data-testid": `ui-modal-${modal.id}-close-button`, type: "button", title: modal.content.closeText, onClick: closeModal },
                    React.createElement("svg", { height: "24", viewBox: "0 0 24 24", width: "24" },
                        React.createElement("path", { d: "m14.8523165 12 8.5569494 8.5569494c.7876455.7876455.7876455 2.0646711 0 2.8523165-.7876454.7876455-2.064671.7876455-2.8523165 0l-8.5569494-8.5569494-8.55694944 8.5569494c-.78764544.7876455-2.06467103.7876455-2.85231647 0-.78764545-.7876454-.78764545-2.064671 0-2.8523165l8.55694943-8.5569494-8.55694943-8.55694944c-.78764545-.78764544-.78764545-2.06467103 0-2.85231647.78764544-.78764545 2.06467103-.78764545 2.85231647 0l8.55694944 8.55694943 8.5569494-8.55694943c.7876455-.78764545 2.0646711-.78764545 2.8523165 0 .7876455.78764544.7876455 2.06467103 0 2.85231647z", fill: "#403294" }))),
                children))), modalRoot);
}
//# sourceMappingURL=Modal.js.map